// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":export {\n  menuText: #fff;\n  menuActiveText: #409EFF;\n  subMenuActiveText: #f4f4f5;\n  menuBg: #4c53e1;\n  menuHover: #4c53e1;\n  subMenuBg: #4c53e1;\n  subMenuHover: #001528;\n  sideBarWidth: 210px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
